// extracted by mini-css-extract-plugin
export default {"container":"Prepare_container__8xxzC","title":"Prepare_title__oesgs","loading_message":"Prepare_loading_message__vI0ho","text":"Prepare_text__KDwNu","button":"Prepare_button__A3XLP"};